module.exports = __webpack_public_path__ + "static/media/reported_post_icon.a26d3b35.svg";